export default "__VITE_ASSET__C2TOi208__"